// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__WvcU1","buttons":"Footer_buttons__m4Nvb"};